module.exports = __webpack_public_path__ + "01ea978f/img/send-icon.3cfb6275.svg";